<template>
  <!-- 国家选择器 -->
  <OaCascader
    class="country-cascader"
    transfer-class-name="country-cascader"
    change-on-select
    filterable
    :data="lists"
    :placeholder="placeholder"
    :transfer="transfer"
    :value="newValue"
    @on-change="onChange"
  ></OaCascader>
</template>

<script>
import OaCascader from '@/components/cascader';
export default {
  data() {
    return {
      lists: [],
      newValue: []
    };
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: function () {
        return this.$t('team.please_select_country');
      }
    },
    transfer: {
      type: Boolean,
      default: false
    },
    init: {
      type: Boolean,
      default: true
    },
    field: {
      type: String,
      default: 'id'
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  components: {
    OaCascader
  },
  mounted() {
    // true：默认请求国家列表数据
    // false：外部手动调用请求数据
    if (this.init) {
      this.getData();
    }
  },
  methods: {
    //获取国家列表
    async getData() {
      const res = await this.$http('get', 'manager/countries/tree');
      const arr = _.map(res.data, (v) => {
        return _.map(v, (v2) => {
          return {
            value: v2[this.field],
            label: v2.name,
            children: _.map(v2.children, (v3) => {
              return {
                value: v3[this.field],
                label: v3.name,
                code: v3.code
              };
            }),
            code: v2.code
          };
        });
      });
      this.lists = _.flatten(arr);
      this.$nextTick(() => {
        this.newValue = this.value;
      });
    },
    onChange(e) {
      const value = this.field === 'id' ? _.map(e, (v) => Number(v)) : e;
      this.newValue = value;
      this.$emit('change', value);
      this.$emit('on-change', value);
    }
  }
};
</script>
<style lang="less">
.country-cascader .ivu-cascader-menu {
  width: auto;
}
</style>
